(function (ws) {
    'use strict';
    ws.views.forgotusername = ws.views.form.extend({

        /**
         * Extend generic form events
         */
        events: _.extend({}, ws.views.form.prototype.events, {
            submit: 'submitEmail'
        }),

        /**
         * Initialize override.
         */
        initialize: function () {
            ws.views.form.prototype.initialize.call(this);
            this.$successTpl = this.$('#comp-forgot-username-success');
            this.$globalMessage = $('#globalMessages');
            this.$mainError = this.$('.form-main-error');
            this.$emailField = this.$('input.email');
            this.$serverError = this.$('.usr-server-error');
            this.$errorMessages = this.$('.error-message');
            this.$modal = this.$el.closest('.modal-container');
            this.render();

            //for spinner
            this.$submitButton = this.$('.usernameSubmit');
        },

        /**
         * Render override.
         */
        render: function () {
            this.successTpl = _.template(this.$successTpl.html());
        },
        /**
         * Additional field validations
         */
        additionalValidation: function () {
            this.checkEmail();
        },

        /**
         * Submit the entered email to verification
         * @param {Event} e - DocumentEvent of type submit
         */
        submitEmail: function (e) {
            e.preventDefault();
            this.$errorMessages.hide();

            if (!this.error) {
                this.$mainError.hide();
                this.model.set('email', this.$('input.email').val());

                //enable Spinner
                this.$submitButton.addClass('spinner-before').prop('disabled', true);

                this.model.save().done(function (response) {

                    //disable spinner
                    this.$submitButton.removeClass('spinner-before').prop('disabled', false);
                    if ($.trim(response.error).length === 0) {
                        this.$globalMessage.html(this.successTpl(response));
                        this.$globalMessage.show();
                        if (this.$modal.length > 0) {
                            this.eventAgg.trigger(this.$modal.prop('id') + 'close');
                        }
                    } else {

                        if (response.redirect) {
                            location.reload();
                        } else {
                            this.$mainError.html(response.error).show();
                            this.$emailField.addClass(this.errorClass);
                        }
                    }
                }.bind(this))
                    .fail(function() {
                        this.$submitButton.removeClass('spinner-before').prop('disabled', false);
                        this.$serverError.show();
                    }.bind(this));
            }
        }
    });
}(westcon));
